
<template>
  <div class="d-flex justify-content-md-between  flex-column flex-md-row mb-5">
    <div class="mb-3">
      <span>Välj elområde:</span><br>
      <div class="my-2 d-flex" style="cursor: pointer;">
        <div for="seradio1" @click="selectArea(SE1, '1')" :class="{ 'btn-secondary': se == 1 }" class="border-end p-2">
          SE1
        </div>
        <div for="seradio2" @click="selectArea(SE2, '2')" :class="{ 'btn-secondary': se == 2 }" class="border-end p-2">
          SE2
        </div>
        <div for="seradio3" @click="selectArea(SE3, '3')" :class="{ 'btn-secondary': se == 3 }" class="border-end p-2">
          SE3
        </div>
        <div for="seradio4" @click="selectArea(SE4, '4')" :class="{ 'btn-secondary': se == 4 }" class="p-2">SE4</div>
      </div>
    </div>

    <div class="mb-3">
      <span>Välj år att visa:</span><br>
      <div class="d-flex my-2" style="cursor: pointer;">
        <template v-for="y, i in selectedArea" :key="i">
          <div class="p-2"
            :class="[{ 'border-end': i + 1 !== selectedArea.length }, { 'btn-secondary': showYears.indexOf(y.name) !== -1 }]"
            :for="'btncheck' + y.name" @click="toggleSeries(y.name)">{{ y.name }}</div>
        </template>

      </div>
    </div>

    <div><span>Visa som:</span><br>
      <div class="my-2 d-flex" style="cursor: pointer;">

        <div for="seradio3" @click="displayTable = false" :class="{ 'btn-secondary': !displayTable }"
          class="border-end p-2">Diagram</div>
        <div for="seradio4" @click="displayTable = true" :class="{ 'btn-secondary': displayTable }" class="p-2">Tabell
        </div>

      </div>
    </div>



  </div>
  <div class="d-flex justify-content-sm-between flex-column flex-sm-row mb-3">
    <h2>Elområde {{ se }}</h2>

    
    

  </div>
  <div v-show="!displayTable">

    <VueApexCharts ref="hChart" type="line" :options="options" :series="series"></VueApexCharts>
  </div>

  <div v-if="displayTable" class="  mb-4 w-100 priceTable d-flex text-center">
    <div class="flex-fill">
      <div class="p-2 bg-light fw-bold">Månad</div>
      <div class="p-2">januari</div>
      <div class="p-2 bg-light">februari</div>
      <div class="p-2">mars</div>
      <div class="p-2 bg-light">april</div>
      <div class="p-2">maj</div>
      <div class="p-2 bg-light">juni</div>
      <div class="p-2">juli</div>
      <div class="p-2 bg-light">augusti</div>
      <div class="p-2">september</div>
      <div class="p-2 bg-light">oktober</div>
      <div class="p-2">november</div>
      <div class="p-2 bg-light">december</div>
    </div>
    <div class="d-flex flex-column flex-fill border-start" v-for="item, key in showYearsArray" :key="key">
      <div class="fw-bold bg-light p-2">{{ item.name }}</div>
      <div class="p-2" v-for="number, i in item.data" :key="i" :class="i % 2 == 0 ? '' : 'bg-light'">{{ number }}
      </div>
    </div>
    <div style="transform: rotate(90deg); margin: auto 0;"><small class="fw-bold">öre/kWh</small></div>
  </div>
  <div class="d-flex justify-content-end">

    <div class="d-flex flex-row">
      <div class="mt-1 me-2">Visa priser inkl. moms. </div>
      <div class="form-check form-switch form-switch-md">
      <input class="form-check-input" type="checkbox" @click="toggleMoms()" id="flexSwitchCheckDefault" checked>
    </div>
    </div>
  </div>









  <componentStyles type="text/css">





    .form-switch.form-switch-md .form-check-input {
    height: 1.5rem;
    width: calc(2rem + 0.75rem);
    border-radius: 3rem;
    }

  </componentStyles>



</template>

<script>

import VueApexCharts from "vue3-apexcharts";
import componentStyles from "../componentStyles.vue"

export default {
  props: { area: { type: String }, initialyears: { type: String } },
  components: { VueApexCharts, componentStyles },
  data() {
    let SE1 = [];
    let SE2 = [];
    let SE3 = [];
    let SE4 = [];
    let se = this.area;
    let maxValue = 0;
    let selectedValues = [];
    let selectedPrices;
    let showYears = this.initialyears.split(",");
    let showYearsArray = [];
    let incmoms = true;
    let displayTable = false;
    let explanation = "*inkl. påslag, elcertifkat och moms.";



    return {

      SE1,
      SE2,
      SE3,
      SE4,
      elcert: {},
      selectedPrices,
      selectedArea: [],
      se,
      maxValue,
      selectedValues,
      showYears,
      showYearsArray,
      explanation,
      incmoms,
      fulljson: [],
      displayTable
    }
  },


  methods: {

    toggleMoms() {
      this.incmoms = !this.incmoms
      console.log(this.incmoms)

      this.sortAndSelect(this.fulljson)
    },

    sortAndSelect(json) {
      this.elcert = json[1];
      this.SE1 = this.sortValues(json[0][1]);
      this.SE2 = this.sortValues(json[0][2]);
      this.SE3 = this.sortValues(json[0][3]);
      this.SE4 = this.sortValues(json[0][4]);

      console.log(this.se)

      if (this.se == "1") { this.selectArea(this.SE1, "1") }
      else if (this.se == "2") { this.selectArea(this.SE2, "2") }
      else if (this.se == "3") { this.selectArea(this.SE3, "3") }
      else if (this.se == "4") { this.selectArea(this.SE4, "4") }
    },

    async fetchPrices() {
      //const req1 = new Request('https://api.gavleenergi.se/Elhandelsshop/HistoriskaPriser', {  
      //  mode: 'no-cors'
      //}); 
      //
      //const req2 = new Request('https://api.gavleenergi.se/Elhandelsshop/HistoriskaElcertpriser', {      
      //  mode: 'no-cors'
      //});
      //let url1 = "https://api.gavleenergi.se/Elhandelsshop/HistoriskaPriser";
      //let url2 = "https://api.gavleenergi.se/Elhandelsshop/HistoriskaElcertpriser";
      //let url3 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/historiska-elpriser/?elomrade";
      let url1 = "https://apps.gavleenergi.se/powerplant-webservice/servicepoint/historiska-elpriser/?elomrade";

      //Promise.all([

        fetch(url1, { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json())
        //fetch(url2).then(res => res.json())
        //fetch(url3, { headers: { 'X-API-KEY': process.env.VITE_API_KEY }, }).then(res => res.json())

      //])
      .then(json => {

        console.log(json)
        this.fulljson = json

        this.sortAndSelect(json)


      })

    },

    sortValues(area) {

      let formattedArea = [];
      let moms;

      if (this.incmoms) {
        moms = 1.25
      } else moms = 1;

      let paslag = 4.72;

      for (const [key, value] of Object.entries(area)) {
        let year = key;
        if (this.elcert[year] != undefined) {

          let elcert = 0;
          let valuesObj = { name: year, data: [] }

          value.map((item, i) => {
            //pusha in tomt objekt i de fall inte alla månader finns än?

            let price = Number(item.split(",")[1]);

            if (this.elcert[year] != undefined) {
              elcert = Number(this.elcert[year][i].split(",")[1])
              
            }
            price = (price + elcert + paslag) * moms;

            valuesObj.data.push(price.toFixed(2))

            if (price > this.maxValue) { this.maxValue = price.toFixed(2) * 1.05 }

          })

          formattedArea.push(valuesObj)
        }
      }
      return formattedArea
    },



    selectArea(area, se) {
      this.selectedArea = area
      this.se = se
      this.checkSeries()
    },

    checkSeries() {
      this.showYearsArray = [];

      this.selectedArea.map(available => {
        if (this.showYears.indexOf(available.name) > -1) {
          this.showYearsArray.push(available)
        }
      })






    },
    toggleSeries(y) {
      if (this.showYears.indexOf(y) > -1) {
        let i = this.showYears.indexOf(y);
        this.showYears.splice(i, 1)
      } else {
        this.showYears.push(y)
      }
      this.checkSeries()
    }

  },

  computed: {



    options: function () {
      return {

        chart: {
          id: 'historiskaElpriser',
          height: '400px',
          toolbar: {
            show: true,
            tools: {
              download: '<i class="fa-regular fa-arrow-down-to-line fa-2x"></i>',
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },


        xaxis: {
          categories: ["jan", "feb", "mar", "apr", "maj", "jun", "jul", "aug", "sep", "okt", "nov", "dec"],
          tickPlacement: 'between',
        },
        yaxis: {
          max: this.maxValue,
          min: 0,

          tickAmount: 5,
          title: {
            text: 'öre/kWh',
            style: {
              fontSize: '14px',
              fontWeight: 500,
              fontFamily: "var(--bs-font-sans-serif)",
            },
          },
        },
        legend: {
          show: true,
          fontFamily: "var(--bs-font-sans-serif)",
          position: 'bottom',
          onItemClick: {
            toggleDataSeries: false
          },
        },
        markers: {
          size: 4,
        },
        stroke: {
          width: 3,
        },
        dataLabels: {
          offsetY: 20,
          style: {
            fontSize: '13px',
            colors: ["#304758"],
          },
        },
        plotOptions: {
          stroke: {
            curve: 'smooth',
          },
        },
        theme: {
          mode: 'light',
          palette: 'palette2',
          monochrome: {
            enabled: false,
            color: '#255aee',
            shadeTo: 'light',
            shadeIntensity: 0.65,
          },
        },
        tooltip: {
          enabled: true,
          enabledOnSeries: undefined,
          shared: true,
          followCursor: true,
          x: { show: true },
          y: { formatter: undefined },
        }
      }
    },
    series: function () {
      return this.showYearsArray
    },



  },



  mounted() {

    this.fetchPrices()
  }
}
</script>
